import mixpanel from "mixpanel-browser";

mixpanel.init("fccdf3a1f42455f7ca3f6026a1b96120"); // Your Mixpanel project token

export default mixpanel;
